import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import CoordinatorResultRelease from '../../../modules/result/@coordinator/results-release/CoordinatorResultRelease';

const CoordinatorResultReleaseList = () => (
  <>
    <TitleHeader title="Results" />
    <ContentTemplate type="full">
      <CoordinatorResultRelease />
    </ContentTemplate>
  </>
);
export default CoordinatorResultReleaseList;
